<template>
  <AppModal  :id="id" :size="size">
    <template v-slot:title>
      <h3 class="text-center mb-5">{{title}}</h3>
    </template>
    <template v-slot:content>
      <slot name="form"></slot>
    </template>
    <template v-slot:button>
      <AppConfirmButtons
        :submit-text="$getConst.pages.button.save"
        :cancel-text="$getConst.pages.button.cancel"
        :isLoading = "isWait"
        @onSubmit="submit"
        @onCancel="close"
      />
    </template>
  </AppModal>
</template>

<script>
  import AppModal from "./AppModal";
  import AppConfirmButtons from "../utils/AppConfirmButtons";
  export default {
    name: "AppConfirmationModal",
    components: {AppConfirmButtons, AppModal},
    props:{
      id: String,
      title: String,
      size: String,
    },
    data() {
      return {
        isWait: false,
      }
    },
    mounted() {
      this.$root.$on('isLoading', loading => {
        this.isWait = loading;
      });
    },
    methods: {
      close() {
        this.$bvModal.hide(this.id);
        this.isWait = false;
        this.$emit('onCancel');
      },
      submit() {
        this.$root.$emit('isSubmited', true);
      },
    }
  }
</script>

<style scoped>

</style>
